import { withLDProvider } from 'launchdarkly-react-client-sdk';
import App from './App';
import configs from './constants/configs';

export default configs.reactAppPreview
    ? App
    : withLDProvider({ clientSideID: configs.launchDarkly })(App);
